import { AppBar, Box, Toolbar } from '@mui/material';
import { FC } from 'react';
import { MediumScreenMenu, MenuItem, SmallScreenMenu } from './menu';

type Props = {
  logo: JSX.Element;
  linkItemConfig: Array<MenuItem>;
  menuComponent: JSX.Element;
};

export const HEADER_HEIGHT = 70;

const Spacer: FC = () => <Box sx={{ flexGrow: 1, display: { xs: 'block', md: 'none' } }} />;

export const HeaderBar: FC<Props> = ({ logo, menuComponent, linkItemConfig }) => {
  return (
    <AppBar
      sx={{
        backgroundColor: 'white',
        boxShadow: 'unset',
        borderRadius: 'unset',
        borderBottomWidth: '1px',
        borderBottomColor: 'grey.50',
        borderBottomStyle: 'solid'
      }}
      position="fixed"
    >
      <Toolbar
        sx={{
          alignItems: 'stretch',
          justifyContent: 'space-between',
          minHeight: {
            xs: `${HEADER_HEIGHT}px`
          }
        }}
      >
        <SmallScreenMenu config={linkItemConfig} />
        {logo}
        <MediumScreenMenu config={linkItemConfig} />
        <Spacer />
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center'
          }}
        >
          {menuComponent}
        </Box>
      </Toolbar>
    </AppBar>
  );
};
